import Link from 'next/link';
import { useEffect, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { GamesGrid } from '@/components/GamesGrid';
import { useGamesProviders } from '@/modules/common/hooks/useGamesProviders';
import { useGetCommonStore } from '@/store';
import type { ISearchFallbackScenariosProps } from '..';
import { ScSearchFallbackScenario } from '../styled';

type ProviderScenarioProps = ISearchFallbackScenariosProps;

export const ProviderScenario: React.FC<ProviderScenarioProps> = ({
  searchPhrase,
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');
  const useCommonStore = useGetCommonStore();

  const { data: providers } = useGamesProviders();
  const setState = useCommonStore.setState;

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });

    return () => {
      setState({ gamesByProviders: {} });
    };
  }, [setState]);

  const providerId = useMemo(() => {
    if (searchPhrase.includes('1spin4')) {
      return '1spin4win';
    }
    if (searchPhrase.includes('platypus')) {
      return 'platipus';
    }
    if (searchPhrase.includes('platipus')) {
      return 'platipus';
    }
    if (searchPhrase.includes('mancala')) {
      return 'mancala';
    }
    if (searchPhrase.includes('netgame')) {
      return 'netgame';
    }
    if (searchPhrase.includes('gamzix')) {
      return 'gamzix';
    }
    if (searchPhrase.includes('pragmatic')) {
      return 'pragmaticplay';
    }

    return searchPhrase;
  }, [searchPhrase]);

  const providerTitle = useMemo(
    () => providers.find(({ id }) => id === providerId)?.title || providerId,
    [providers, providerId]
  );

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href={`/games/all/${providerId}#gamesSection`}
                  onClick={closeModal}
                />
              ),
            }}
            i18nKey="searchFallback.subtitle.provider"
            ns="lobby"
            values={{ provider: providerTitle }}
          />
        </p>
      </div>
      <GamesGrid
        provider={providerId}
        {...gridOptions}
        onDemoClick={(game) => handleSearchGameClick(game, 'custom_providers')}
        onPlayClick={(game) => handleSearchGameClick(game, 'custom_providers')}
      />
    </ScSearchFallbackScenario>
  );
};
